/* eslint-disable */
import * as React from "react";
import { last, first } from "lodash";
import { ReportToolbar, ReportToolbarGroup, ReportToolbarSpacer, ReportToolbarNumber } from "../../components/ReportToolbar";
import { ReportGrid } from "../../components/ReportGrid";
import { ReportLayout } from "../../components/ReportLayout";
import { ReportHeader } from "../../components/ReportHeader";
import { ReportContainer } from "../../components/ReportContainer";
import { ReportRenderer, useParameter, yearToCropYearShort, useDictionaryItem } from "../../shared";
import { CalendarControl } from "./controls/CalendarControl";
import { CommoditiesControl } from "./controls/CommoditiesControl";
import { BusinessUnitControl } from "./controls/BusinessUnitControl";
import { useExportQuery } from "./export/useExportQuery";
import { useFavourite } from "./favourite/useFavourite";
import { useSubscription } from "./subscription/useSubscription";
import { dictionaryService } from "../../dataFlow";

export default function (props: { exportMode?: boolean }) {
  const { exportMode } = props;

  const [commName, setCommName] = React.useState("");
  const [commodities] = useParameter<string[]>("@commodities_display");
  const [business, setBusiness] = useParameter<number>("@business-units");
  const [commodityItem, commodityName] = useDictionaryItem(dictionaryService, "slides-commodities-display", Number(last(commodities)), {
    business_unit: Number(business),
    slide: 5,
  });
  React.useEffect(() => {
    if (commodityItem && commodityName) {
      const isSugarcane = String(last(commodities)) === "120000";
      setCommName(isSugarcane ? `${commodityName[9]}**` : commodityName[9]);
    }
  }, [commodityItem, commodityName]);

  const [calendar] = useParameter<number[]>("@calendar");
  const [, calendarName] = useDictionaryItem(dictionaryService, "slides-calendar", first(calendar));
  const year = calendarName ? Number(calendarName) : new Date().getFullYear() - 1;
  const usdaSubtitle = `USDA marketing year (eg. ${yearToCropYearShort(year)} = Crop Year ${yearToCropYearShort(year - 1)})`;
  const comment = commodityItem?.getValue<string | null>("comment");
  const subtitle = !comment && comment !== "" ? usdaSubtitle : comment;
  const bname = (business || 1) === 2 ? "APE" : "World";
  const title = React.useMemo(
    () => `${bname} overview (incl. forecast) – ${commName} area, production, yield & net trade`,
    [commName, business]
  );
  const description =
    Number(business) === 2
      ? [
          "Showing historical and future development of Crop Area, Production and Yield",
          "Net Trade graphic information is based on the Top 5 Exporters and Top 5 Importers",
          "     Source: USDA PS&D (Field crops), USDA Projection 2013, FAO (Fruits & Vegetables), Global Insight and Eurostat for individual EU countries",
          "Marketing Year: The marketing year starts directly after the crop year. In this period the crop finds it way to the market. E.g. the marketing year 11-12 markets the crops grown in the crop year 10-11",
        ]
      : [
          "Showing historical and future development of Crop Area, Production and Yield",
          "Net Trade graphic information is based on the Top 5 Exporters and Top 5 Importers",
          "Source:  USDA PS&D (Field crops), USDA Projection 2013, FAO (Fruits & Vegetables), OECD FAO (Sugar Crops) and Global Insight",
          "Marketing Year: The marketing year starts directly after the crop year.  In this period the crop finds it way to the market. E.g. the marketing year 11-12 markets the crops grown in the crop year 10-11",
        ];

  useExportQuery(title, subtitle);
  const { isFavouriteLoading } = useFavourite();
  useSubscription();

  const defaultBusiness = React.useMemo(() => business, []);
  React.useEffect(() => {
    return () => {
      setBusiness(defaultBusiness || null);
    };
  }, []);

  return (
    <ReportContainer>
      <ReportHeader title={title} subtitle={subtitle} description={description} exportMode={exportMode} />
      <ReportToolbar exportMode={exportMode}>
        <ReportToolbarGroup isLoading={isFavouriteLoading}>
          <BusinessUnitControl />
          <CommoditiesControl key={business || undefined} />
          {/* <CalendarControl /> */}
        </ReportToolbarGroup>
        <ReportToolbarSpacer />
        <ReportToolbarNumber number={5} />
      </ReportToolbar>
      <ReportLayout>
        <ReportGrid>
          <ReportRenderer componentId="chart-area-production-yield" />
          <ReportRenderer componentId="chart-net-trade" />
        </ReportGrid>
      </ReportLayout>
    </ReportContainer>
  );
}
